<template>
  <v-dialog
    v-model="show"
  >
    <template #activator="{ attrs, on }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        text
        small
      >
        Importer fra varenumre
        <v-icon right>
          mdi-import
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        Import varer
      </v-card-title>
      <v-card-text>
        <PartBulkCSVImport @import="onImport" />
      </v-card-text>
      <v-card-text>
        <v-fade-transition>
          <div v-if="linesToImport.length">
            <h4>Varer fundet:</h4>
            <v-list>
              <v-list-item
                v-for="line of linesToImport"
                :key="line.partNumber"
              >
                <v-list-item-avatar>
                  <v-img
                    :src="line.part?.imageUrl"
                    :lazy-src="require('@/assets/missing-image.png')"
                    contain
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-title>
                  {{ line.part.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </div>
        </v-fade-transition>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="close">
          {{ $t('common.cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="!linesToImport.length">
          Import {{ linesToImport.length }} varer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PartBulkCSVImport from '../part/PartBulkCSVImport.vue';

export default {
  name: 'SpecificationPartBulkImport',
  components: {
    PartBulkCSVImport
  },
  data() {
    return {
      show: false,
      linesToImport: []
    }
  },
  methods: {
    onImport(parts) {
      this.linesToImport = parts;
    },
    close() {
      this.linesToImport = [];
      this.show = false;
    }
  }
}
</script>